import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Warsaw" />

        <footer className="Footer">
          This project was coded by{" "}
          <a
            href="https://www.linkedin.com/in/joanna-goljanek"
            target="_blank"
            rel="noreferrer"
          >
            Joanna Goljanek
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/coding-joanna/react-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://timely-dango-a8f2f2.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
